/**
 * Prompt used by the Claim Details AI Summary card.
 * Asks the model for exactly two labeled sections so the UI can parse them reliably.
 */
export const CLAIM_AI_SUMMARY_PROMPT = `Summarize this claim in a concise and structured way. Focus on the most important information, key entities (such as claims, patients, balances, and payments), and any critical updates or issues.

Instructions:
1. Produce exactly two sections:

Summary:
- 2–3 sentences.
- Start with the claim status.
- Mention payer, claim type, and current processing stage if available.
- Include only the most important facts affecting the claim.
- Mention important financial information when relevant (ERA, payments, balances, patient responsibility, denials, etc.).
- Mention issues requiring attention (unmatched payments, missing authorization, coding/modifier mismatches, rejected services, missing documentation, duplicates, etc.).
- Do NOT simply list every event from the timeline.
- Focus on what a billing specialist needs to know right now.

Recommended next step:
- One short sentence.
- Begin with an action verb.
- Recommend the single highest-priority action needed to move the claim forward.
- If no action is required, say: "No action required at this time."

Example output:
Summary: Claim is OPEN and in active adjudication with FL BCBS (Commercial). An ERA for $325.89 was received on Jun 9, but three line payments remain unmatched. Lines 1 and 2 have a modifier 95 discrepancy, and Line 3 (97530-95) has no likely payment match. No patient responsibility has been determined yet.
Recommended next step: Reconcile the three unmatched payments and resolve the modifier 95 mismatch before closing the claim.`;
